@if (mode !== verificationModes.PASSWORD_RESET) {
  <div>
    <button class="ficon-arrow-left back-btn" role="button" aria-label="back" (click)="back()"></button>
  </div>
}

<section class="content" aria-labelledby="email-verification-title" aria-describedby="email-verification-description">
  <h2
    id="email-verification-title"
    class="title"
    translate="{{mode === verificationModes.PASSWORD_RESET ? 'email-verification_reset_title' : 'email-verification_title'}}">
  </h2>

  <p id="email-verification-description" class="description fullstory-ignore" translate="email-verification_description" [translateParams]="{email}"></p>

  <code-input #codeInput
    [autoFocus]="true"
    [disabled]="loading || needToResendCode"
    [ariaDescribedBy]="error ? 'email-verification-code-error' : null"
    [ariaInvalid]="error ? 'true' : null"
    (onChange)="codeValueChange$.next($event)"
    [class.loading]="loading || needToResendCode"
  ></code-input>

  <p class="accessibility-text" aria-live="polite">{{ validatingCode ? ('email-verification_validating_code' | translate) : '' }}</p>
  <p
    id="email-verification-code-error"
    class="verification-error"
    aria-live="assertive"
    data-cy="email-verification-code-invalid">
    {{error | translate}}
  </p>

  <p class="resend-code-wrapper">
    <span>
      <span id="email-verification-resend-code"><span translate="email-verification_did_not_email"></span> <span class="accessibility-text" translate="common_resend-code"></span></span>

      <button
        class="resend-code-btn"
        [attr.aria-label]="'common_resend-code' | translate"
        [attr.aria-pressed]="resendCodeloading"
        [attr.tabindex]="resendCodeCountDownTime() > 0 ? -1 : 0"
        [class.accessibility-text]="resendCodeCountDownTime() > 0"
        (click)="resendCodeloading ? null : resendCode($event, countDown)">
        {{resendCodeloading ? ('common_please-wait' | translate) + '...' : ('common_resend-code' | translate)}}
      </button>

      <span
        #countDown
        [class.accessibility-text]="resendCodeCountDownTime() === 0"
        [attr.tabindex]="resendCodeCountDownTime() > 0 ? 0 : -1"
        role="button"
        aria-disabled="true"
        [attr.aria-label]="'email-verification_resend-code-unavailable' | translate"
        class="count-down-timer">
        <span>{{resendCodeCountDownTime()}}s</span>
      </span>
    </span>

    <button
      type="button"
      class="icon help-icon ficon-app-help-circle-outline btn-none"
      [attr.aria-label]="'common_learn-more' | translate"
      [goCdkPopover]="'sign-up-not-received-email' | translate"
    ></button>
  </p>
</section>
